import React, { useState, useEffect } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { MdOutlineFileUpload } from "react-icons/md";
import "./index.css";
import apiUrls from "../../../Api/MainApi";
import { MDBInput } from 'mdb-react-ui-kit';
import axios from "axios";
import { Select } from "antd";

const BankDetailsForm = ({ formData, setFormData, setIsFormValid }) => {
  // State variables
  const [AccountHolderName, setAccountHolderName] = useState("");
  const [AccountNo, setAccountNo] = useState("");
  const [IFSCCode, setIFSCCode] = useState("");
  const [BankName, setBankName] = useState(null);
  const [CancelledCheque, setCancelledCheque] = useState(null); // Assuming CancelledCheque is a file object
  const [errors, setErrors] = useState({});
  const [bankOptions, setBankOptions] = useState([]);
  const [SearchTextBank, setSearchTextBank] = useState("");
  const [fileNames, setFileNames] = useState({}); // State to hold file names

  // Effect to fetch bank names based on search text
  useEffect(() => {
    const fetchData = async () => {
      try {
        const BankNameData = await axios.post(apiUrls.GetBankNameDropDown, { SearchText: SearchTextBank });
        setBankOptions(BankNameData.data.data);
      } catch (error) {
        console.error("Error fetching bank names:", error);
      }
    };
    fetchData();
  }, []);

  // Handler for form input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    let newValue = value;
  
    // Regex validation for AccountNo
    if (name === "AccountNo") {
      newValue = value.replace(/\D/g, "");
    }
  
    // Regex validation for IFSCCode
    if (name === "IFSCCode") {
      newValue = value.toUpperCase().replace(/[^a-zA-Z0-9-]/g, "");
    }
  
    // Update formData
    setFormData({
      ...formData,
      [name]: newValue,
    });
  
    // Update the state
    switch (name) {
      case "AccountHolderName":
        setAccountHolderName(newValue);
        break;
      case "AccountNo":
        setAccountNo(newValue);
        break;
      case "IFSCCode":
        setIFSCCode(newValue);
        break;
      case "CancelledCheque":
        if (files && files[0]) {
          const file = files[0];
          setFileNames(prevFileNames => ({ ...prevFileNames, [name]: files[0].name })); // Set file name
          const reader = new FileReader();
  
          reader.onloadend = () => {
            const fileData = {
              name: file.name,
              data: reader.result, // Base64 encoded data
            };
            const fileDataString = JSON.stringify(fileData);
            setCancelledCheque(fileDataString); // Store file data with base64
            setFormData({
              ...formData,
              CancelledCheque: fileDataString,
            });
          };
  
          reader.readAsDataURL(file); // Convert file to base64
        }
        break;
      default:
        break;
    }
  
    // Validate the input value and set error
    const newErrors = { ...errors };
    switch (name) {
      case "AccountHolderName":
        newErrors.AccountHolderName = /^[A-Za-z\s]+$/.test(value.trim()) ? "" : "Account holder name should contain only letters and spaces";
        setIsFormValid(false);
        break;
      case "AccountNo":
        newErrors.AccountNo = value.trim() ? (/^\d+$/.test(value.trim()) ? "" : "Account number should contain only digits") : "Account number is required";
        setIsFormValid(false);
        break;
      case "IFSCCode":
        newErrors.IFSCCode = value.trim() ? (/^[A-Za-z]{4}\d{7}$/.test(value.trim()) ? "" : "IFSC code should be in the format: ABCD1234567") : "IFSC code is required";
        setIsFormValid(false);
        break;
      default:
        setIsFormValid(true);
        break;
    }
  
    setErrors(newErrors);
  };
  

  // Handler for bank name selection
  const handleBankNameChange = (selectedOption) => {
    setBankName(selectedOption);
    setSearchTextBank(selectedOption.label); // Update the search text based on selection
    setErrors({ ...errors, BankName: "" }); // Clear error message when bank name is selected
    setFormData(prevFormData => ({
      ...prevFormData,
      BankName: selectedOption, // Set the selected bank object
    }));
  };

  // Function to validate form on submission
  const validateForm = () => {
    const newErrors = {};

    // Validate AccountHolderName
    if (!AccountHolderName.trim()) {
      newErrors.AccountHolderName = "Account holder name is required";
      setIsFormValid(false)
    }

    // Validate AccountNo
    if (!AccountNo.trim()) {
      newErrors.AccountNo = "Account number is required";
      setIsFormValid(false)
    } else if (!/^\d+$/.test(AccountNo.trim())) {
      newErrors.AccountNo = "Account number should contain only digits";
      setIsFormValid(false)
    }

    // Validate IFSCCode
    if (!IFSCCode.trim()) {
      newErrors.IFSCCode = "IFSC code is required";
      setIsFormValid(false)
    } else if (!/^[A-Za-z]{4}\d{7}$/.test(IFSCCode.trim())) {
      newErrors.IFSCCode = "IFSC code should be in the format: ABCD1234567";
      setIsFormValid(false)
    }

    // Validate BankName
    if (!BankName) {
      newErrors.BankName = "Bank name is required";
      setIsFormValid(false)
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };

  // Handler for form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      // Submit form or perform other actions
    } else {
      // Form validation failed
      console.log("Form validation failed");
    }
  };
  const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <div className="FormCss">
      <div className="form-container">
        <Container>
          <Row>
            <Col>
              <Form
                className="form-md position-relative"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <h3 className="mb-3">Bank Details</h3>
                <div className="form-section">
                  <div className="input-row">
                    <div className="form-group">
                      <MDBInput
                        type="text"
                        name="AccountHolderName"
                        value={formData.AccountHolderName}
                        onChange={handleChange}
                        required
                        id="AccountHolderName"
                        label="Account Holder Name"
                      />
                      {errors.AccountHolderName && (
                        <div className="error-message" style={{ color: 'red' }}>{errors.AccountHolderName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <MDBInput
                        type="text"
                        name="AccountNo"
                        value={formData.AccountNo}
                        onChange={handleChange}
                        required
                        id="AccountNo"
                        label="Account Number"
                      />
                      {errors.AccountNo && (
                        <div className="error-message" style={{ color: 'red' }}>{errors.AccountNo}</div>
                      )}
                    </div>
                  </div>
                  <div className="input-row">
                    <div className="form-group">
                      <MDBInput
                        type="text"
                        name="IFSCCode"
                        value={formData.IFSCCode}
                        onChange={handleChange}
                        required
                        id="IFSCCode"
                        placeholder="SBIN0005943"
                        label="IFSC Code"
                      />
                      {errors.IFSCCode && (
                        <div className="error-message" style={{ color: 'red' }}>{errors.IFSCCode}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <Select
                        name="BankName"
                        value={formData.BankName}
                        onChange={handleBankNameChange}
                        filterOption={filterOption}
                        onInputChange={(inputValue) => setSearchTextBank(inputValue)}
                        options={(bankOptions || []).map((bank) => ({ value: bank.id, label: bank.name }))}
                        placeholder="Select Bank Name"
                        required
                        id="BankName"
                        aria-placeholder="Bank Name"
                        style={{ width: '100%', height: "42px" }}
                      />
                      {errors.BankName && (
                        <div className="error-message" style={{ color: 'red' }}>{errors.BankName}</div>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-group" style={{ position: "relative" }}>
                      <MdOutlineFileUpload className="upload-icon-for-inputs" />
                      <Form.Control
                        style={{
                          cursor: "pointer",
                          borderRadius: "5px",
                          paddingLeft: "40px",
                        }}
                        type="text"
                        value={fileNames.CancelledCheque || ""}
                        placeholder="Upload Canceled Cheque"
                        readOnly
                        onClick={() =>
                          document.getElementsByName("CancelledCheque")[0].click()
                        }
                      />
                      <Form.Control
                        type="file"
                        name="CancelledCheque"
                        onChange={handleChange}
                        style={{ display: "none" }}
                        accept='image/*,.pdf'
                      />
                    </div>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default BankDetailsForm;
